<template>
    <div>
        <v-text-field
            :model-value="localValue ? localValue.format(localDisplayFormat) : ''"
            :label="label"
            :append-inner-icon="clearable && localValue ? 'clear' : ''"
            :disabled="disabled"
            :error-messages="errorMessages"
            :rules="rules"
            :hide-details="hideDetails"
            type="button"
            @click:appendInner.stop="localValue = null"
            @blur="$emit('blur')"
        >
            <v-menu
                :close-on-content-click="false"
                v-model="menu"
                activator="parent"
                transition="scale-transition"
            >
                <div class="bg-white d-flex flex-column rounded elevation-18" style="width: 350px !important;" :style="{height: ['datetime', 'time'].includes(type) ? 'height: 470px !important' : '400px !important'}">
                    <v-tabs v-model="tabs" color="secondary" class="flex-grow-0" grow v-if="type == 'datetime'">
                        <v-tab value="1" v-if="type == 'datetime' || type == 'date'">تاریخ</v-tab>
                        <v-tab value="2" v-if="type == 'datetime' || type == 'time'">ساعت</v-tab>
                    </v-tabs>
                    <v-tabs-window class="pa-4 pb-0 flex-grow-1" v-model="tabs">
                        <v-tabs-window-item value="1" v-if="type == 'datetime' || type == 'date'">
                            <v-date-picker
                                color="secondary"
                                show-adjacent-months
                                hide-header
                                :min="dateMin"
                                :max="dateMax"
                                v-model="dateValue"
                                @update:modelValue="tabs = type == 'datetime' ? '2' : '1'"
                            ></v-date-picker>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="2" v-if="type == 'datetime' || type == 'time'">
                            <v-time-picker
                                title=" "
                                class="pa-0"
                                format="24hr"
                                color="secondary"
                                :min="timeMin"
                                :max="timeMax"
                                scrollable
                                full-width
                                v-model="timeValue"
                            ></v-time-picker>
                        </v-tabs-window-item>
                    </v-tabs-window>
                    <div class="ma-3">
                        <v-btn color="success" variant="flat" :disabled="!submitable" @click="submit">ثبت</v-btn>
                        <v-btn color="error" variant="text" class="ms-3" @click="menu = false">انصراف</v-btn>
                        <v-btn color="secondary" variant="text" class="ms-3" :disabled="!nowable" @click="setToNow">اکنون</v-btn>
                    </div>
                </div>
            </v-menu>
        </v-text-field>
    </div>
</template>
<script>
import { VTimePicker } from 'vuetify/labs/VTimePicker'
export default {
    components: {
        VTimePicker,
    },
    props: {
        modelValue: {
            required: true,
            default: null
        },
        label: {
            default: 'تاریخ...'
        },
        type: {
            default: 'datetime' // submit
        },
        displayFormat: {
            default: ''
        },
        returnFormat: {
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false
        },
        min: {
            default: null
        },
        max: {
            default: null
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            default: () => []
        },
        rules: {
            default: () => []
        },
    },
    data() {
        return {
            tabs: null,
            menu: false,
            dateValue: null,
            timeValue: null
        };
    },
    computed: {
        localValue: {
            get: function () {
                if (!this.modelValue)
                    return null;
                let value = this.$moment(this.modelValue, this.localReturnFormat, true);
                if (value.isValid() && value.format(this.localReturnFormat) === this.modelValue)
                    return value;
                value = this.$moment(this.modelValue, /^\d+$/.test(this.modelValue) ? 'X' : false);
                this.$emit('update:modelValue', value.format(this.localReturnFormat));
                return value;
            },
            set: function (value) { this.$emit('update:modelValue', value ? value.format(this.localReturnFormat) : null)}
        },
        momentMin() {
            return !this.min ? null : (this.$moment.isMoment(this.min) ? this.min : this.$moment(this.min, this.localReturnFormat));
        },
        momentMax() {
            return !this.max ? null : (this.$moment.isMoment(this.max) ? this.max : this.$moment(this.max, this.localReturnFormat));
        },
        dateMin() {
            return this.momentMin ? this.momentMin.clone().startOf('day') : null;
        },
        dateMax() {
            return this.momentMax ? this.momentMax.clone().endOf('day') : null;
        },
        timeMin() {
            return this.momentMin && (this.type == 'time' || this.momentMin.isSame(this.dateValue, 'day')) ? this.momentMin.format('HH:mm') : null;
        },
        timeMax() {
            return this.momentMax && (this.type == 'time' || this.momentMax.isSame(this.dateValue, 'day')) ? this.momentMax.format('HH:mm') : null;
        },
        nowable() {
            if (this.type == 'datetime')
                return !!(!this.momentMin || this.momentMin.isBefore(this.$moment())) && (!this.momentMax || this.momentMax.isAfter(this.$moment()));
            if (this.type == 'date')
                return !!(!this.dateMin || this.dateMin.isBefore(this.$moment())) && (!this.dateMax || this.dateMax.isAfter(this.$moment()));
            return !!(!this.timeMin || this.timeMin < this.$moment().format('HH:mm')) && (!this.timeMax || this.timeMax > this.$moment().format('HH:mm'));
        },
        submitable() {
            if (this.type == 'time')
                return this.timeValue && this.timeValue.split(':').length == 2;
            if (this.type == 'date')
                return this.dateValue && this.dateValue.isValid();
            return this.timeValue && this.timeValue.split(':').length == 2 && this.dateValue && this.dateValue.isValid();
        },
        localReturnFormat() {
            if (this.returnFormat)
                return this.returnFormat;
            return this.type == 'time' ? 'HH:mm' : 'X';
        },
        localDisplayFormat() {
            if (this.displayFormat)
                return this.displayFormat;
            return this.type == 'time' ? 'HH:mm' : this.type == 'datetime' ? 'HH:mm jYYYY/jMM/jDD' : 'jYYYY/jMM/jDD';
        },
    },
    watch: {
        localValue() {
            this.setModelValues();
        }
    },
    methods: {
        setToNow() {
            this.dateValue = this.$moment().startOf('day');
            this.timeValue = this.$moment().format('HH:mm');
        },
        submit() {
            const date = ['datetime', 'date'].includes(this.type) ? this.dateValue : this.$moment();
            const time = ['datetime', 'time'].includes(this.type) ? this.timeValue.split(':') : ['00', '00'];
            this.localValue = date.clone().hour(time[0]).minute(time[1]);
            this.menu = false;
        },
        setModelValues() {
            this.tabs = this.type == 'datetime' || this.type == 'date' ? '1' : '2';
            this.dateValue = this.localValue ? this.localValue.clone().startOf('day') : null;
            this.timeValue = this.localValue ? this.localValue.format('HH:mm') : null;
        }
    },
    beforeMount() {
        this.setModelValues();
    }
}
</script>
<style>
.v-picker-title {
    margin: 0 !important;
}
.v-time-picker-controls {
    margin: 0 !important;
    margin-bottom: 10px !important;
}
.v-time-picker-clock {
    margin: 0 auto !important;
}
</style>
